import { debounce } from "@utils";
import { create } from "zustand";

interface SearchStoreState {
  searchQuery: string | null;
  search: (query: string) => void;
}

export const useRecipeSearchStore = create<SearchStoreState>((set, get) => ({
  searchQuery: null,
  search: (searchQuery) => {
    debounce(() => set({ searchQuery }), "search", 400);
  },
}));

export function useRecipeSearchQuery() {
  return useRecipeSearchStore((store) => store.searchQuery);
}

export const useRecipeWishlistSearchStore = create<SearchStoreState>((set, get) => ({
  searchQuery: null,
  search: (searchQuery) => {
    debounce(() => set({ searchQuery }), "search", 200);
  },
}));

export function useRecipeWishlistSearchQuery() {
  return useRecipeWishlistSearchStore((store) => store.searchQuery);
}
